module.exports = __webpack_public_path__ + "res/4-img_top_center.fd0fd1f640c27a6f04126da15a7be15b.png";